import Vue from 'vue';
import axios from 'axios';
import * as config from '../assets/Json/config.json';

const version = 'v1';
const canRegisterEmailApi = `${version}/Registration/canRegisterEmail`;
const registerCompanyDetailsApi = `${version}/Registration/registerCompanyDetails`;
const verifyEmailApi = `${version}/Registration/verifyEmail`;
const addSubscriptionDetailsApi = `${version}/Registration/addSubscriptionDetails`;
const preparePaymentApi = `${version}/Registration/preparePayment`;
const paymentSetupSuccessApi = `${version}/Registration/paymentSetupSuccess`;
const getJwtApi = `${version}/User/getJwt`;

export const state = Vue.observable({});

export const mutations = {
	async setSignupJwt() {
		let res = await axios.get(`${getJwtApi}/${config.businessTokenKey}`);
		if (res.data.success) {
			let signupJwt = res.data.result;
			axios.defaults.headers.common['Authorization'] = `Bearer ${signupJwt}`;
			return signupJwt;
		}

		return '';
	},
	async canRegisterEmail(registerEmailRequest) {
		return await axios.post(canRegisterEmailApi, registerEmailRequest);
	},
	async registerCompanyDetails(registerCompanyDetailsRequest) {
		return await axios.post(registerCompanyDetailsApi, registerCompanyDetailsRequest);
	},
	async verifyEmailAddress(request) {
		return await axios.post(verifyEmailApi, request);
	},
	async addSubscriptionDetails(request) {
		return await axios.post(addSubscriptionDetailsApi, request);
	},
	async preparePayment(request) {
		return await axios.post(preparePaymentApi, request);
	},
	async registerCompany(request) {
		return await axios.post(paymentSetupSuccessApi, request);
	}
}
